import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { useTabNotifications } from '../../../contexts/TabNotificationContext'

export interface UnderlineTabItem {
  value: string
  label: string
}

interface UnderlineTabBarProps {
  tabs: UnderlineTabItem[]
  selectedTab: string
  onSelectTab: (tab: string) => void
  compact?: boolean
}

const UnderlineTabBar: React.FC<UnderlineTabBarProps> = ({ tabs, selectedTab, onSelectTab, compact = false }) => {
  const { notificationTabs } = useTabNotifications()

  return (
    <Box width="100%" minW={0}>
      <HStack
        spacing={{ base: '8px', md: compact ? '16px' : '24px' }}
        align="stretch"
        px={{ base: '12px', md: '20px' }}
        pt={{ base: '6px', md: '10px' }}
        pb="0"
        borderBottomColor="solid.50"
        borderBottomWidth="1px"
        overflowX={{ base: 'auto', md: compact ? 'auto' : 'visible' }}
        css={
          compact
            ? {
                '&::-webkit-scrollbar': { height: '4px' },
                '&::-webkit-scrollbar-thumb': { background: '#CBD5E0', borderRadius: '4px' },
                scrollbarWidth: 'thin',
              }
            : {
                '&::-webkit-scrollbar': { display: 'none' },
                scrollbarWidth: 'none',
              }
        }
      >
        {tabs.map((tab) => {
          const isSelected = selectedTab === tab.value
          const hasTabNotification = notificationTabs.has(tab.value)
          return (
            <HStack
              key={tab.value}
              spacing="12px"
              py={{ base: '12px', md: '14px' }}
              px={{ base: '12px', md: compact ? '12px' : '16px' }}
              height={{ base: '44px', md: '48px' }}
              flexShrink={0}
              cursor="pointer"
              color="solid.900"
              onClick={() => onSelectTab(tab.value)}
              borderBottomColor={isSelected ? 'primary.100' : 'transparent'}
              borderBottomWidth={isSelected ? '2px' : '0px'}
              mb="-1px"
              transition="all 0.15s ease-out"
              sx={{
                '@media (hover: hover)': {
                  '&:hover': { bg: '#D0DDFF4D' },
                },
              }}
            >
              <Text
                textStyle="l-s"
                fontWeight={isSelected ? '600' : '500'}
                color={isSelected ? 'primary.100' : 'solid.900'}
              >
                {tab.label}
              </Text>
              {hasTabNotification && (
                <Box
                  w="6px"
                  h="6px"
                  borderRadius="full"
                  bg="#ae68ff"
                  flexShrink={0}
                />
              )}
            </HStack>
          )
        })}
      </HStack>
    </Box>
  )
}

export default UnderlineTabBar
